var React = require('react');

function CorouselLeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"15.5","transform":"rotate(-180 16 16)","stroke":"white","key":0}),React.createElement("path",{"d":"M18 24L13 16.5L18 9","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CorouselLeftArrow.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CorouselLeftArrow;

CorouselLeftArrow.default = CorouselLeftArrow;
